import scopes from './scopes';

export default scopes;
